import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export default function LoadingAnimation() {
  const { t } = useTranslation()
  const words = t('loading.words', { returnObjects: true })
  const [index, setIndex] = useState(0)
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false)
      setTimeout(() => {
        setIndex((i) => (i + 1) % words.length)
        setVisible(true)
      }, 400)
    }, 1500)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="loading-row">
      <span
        style={{
          opacity: visible ? 1 : 0,
          transition: 'opacity 0.4s',
          color: 'var(--primary)',
          fontStyle: 'italic',
          fontSize: '0.85rem',
        }}
      >
        {words[index]}
      </span>
    </div>
  )
}
